// extracted by mini-css-extract-plugin
export var activeDot = "_5h-c";
export var buttonContainer = "_5h-9";
export var channelButton = "_5h-a";
export var clickable = "_5h-d";
export var content = "_5h-0";
export var contentFull = "_5h-2";
export var contentThird = "_5h-1";
export var contentWrapper = "_5h-7";
export var description = "_5h-5";
export var heightShort = "_5h-f";
export var image = "_5h-3";
export var imageContainer = "_5h-4";
export var selectButton = "_5h-e";
export var spinnerContainer = "_5h-b";
export var titleContent = "_5h-8";
export var titleWrapper = "_5h-6";